import { createFileRoute } from "@tanstack/react-router";
import { CrudManager } from "@/components/admin/CrudManager";

export const Route = createFileRoute("/admin/depoimentos")({ component: Page });

function Page() {
  return (
    <CrudManager
      table="testimonials"
      label="Depoimentos"
      fields={[
        { name: "author_name", label: "Nome", type: "text", required: true },
        { name: "author_role", label: "Cargo / função", type: "text" },
        { name: "quote", label: "Depoimento", type: "textarea", required: true, fullWidth: true },
        { name: "photo_url", label: "Foto", type: "image" },
        { name: "sort_order", label: "Ordem", type: "number" },
        {
          name: "status",
          label: "Status",
          type: "select",
          options: [
            { label: "Rascunho", value: "draft" },
            { label: "Publicado", value: "published" },
            { label: "Oculto", value: "hidden" },
          ],
        },
      ]}
      columns={[
        { key: "author_name", label: "Nome" },
        { key: "author_role", label: "Cargo" },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
